/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/22/18
 * Copyright All Rights Reserved
 */
import { Link } from 'react-router-dom';
import React from 'react';
import NavLinkGroup from 'components/NavLinkGroup';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <NavLinkGroup className="pull-right">
        <ul>
          <li>&copy; {(new Date()).getFullYear()} <a href="https://www.hbrisk.com" target="_blank" rel="noopener noreferrer">Haselton Baker Risk Group</a></li>
          <li>|</li>
          <li><a href="https://www.hbrisk.com/contact" target="_blank" rel="noopener noreferrer">Contact</a></li>
          <li>|</li>
          <li><Link to="/terms">Terms of Use</Link></li>
        </ul>
      </NavLinkGroup>
    </div>
  </footer>
);

export default Footer;
